import gql from 'graphql-tag';

import { lessonFragment } from '~/shared/graphql-queries/lessons/index';

export default gql`
  query findCurrentUnfinishedLessonQuery(
    $courseId: MongoID!
    $userId: MongoID
  ) {
    findCurrentUnfinishedLessonQuery(courseId: $courseId, userId: $userId) {
      ...LessonFragment
    }
  }
  ${lessonFragment}
`;
